<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual id="rearing" title="Solution" src="/images/sub/subvisual-solution.jpg"></sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section class="page-section--first">
            <template #titleLine>
                Vertical farm facility
            </template>
            <tit-wrap-large class="mb-0">
                <b>The hydroponic management system</b> <br class="d-none d-lg-block" />that enables the cultivation <br class="d-none d-lg-block" />of higher-quality agricultural products
                <template #text>Based on root zone measurement and control technology as the basics of crop cultivation, <br class="d-none d-lg-block" />the system enables precise agriculture for optimal produce by supplying the most suitable nutrient solutions to the crops.</template>
            </tit-wrap-large>
        </page-section>

        <page-section class="page-section--last grey lighten-5">
            <page-section class="page-section--sm py-0">
                <template #pageSectionImmersive>
                    <v-row class="mx-n20px my-n10px mx-md-n30px my-md-n20px">
                        <v-col cols="12" md="6" class="px-20px py-10px px-md-30px py-md-20px" data-aos="fade-left" data-aos-delay="200">
                            <v-card outlined rounded="">
                                <v-img max-width="570" :aspect-ratio="570 / 456" src="/images/sub/solution/plant/rearing-img.jpg" class="mx-auto" />
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6" class="px-20px py-10px px-md-30px py-md-20px" data-aos="fade-right" data-aos-delay="200">
                            <div class="mt-md-24px">
                                <tit-wrap-sprout>
                                    Vertical Farm Cultivation Shelf System
                                    <template #text>
                                        Real-time monitoring of the growth environment of greenhouse crops
                                    </template>
                                </tit-wrap-sprout>

                                <txt-item titleClass="w-md-140px">
                                    <template #title>Composition</template>
                                    Supply detection unit, drainage detection unit, weight detection unit, nutrient solution supply unit, display unit, control unit, and warning unit
                                </txt-item>
                                <div class="mt-16px mt-md-24px">
                                    <v-img max-width="570" :aspect-ratio="570 / 158" src="/images/sub/solution/plant/rearing-img2-en.png" class="mx-auto" />
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </template>
            </page-section>

            <page-section class="page-section--sm pb-0">
                <template #pageSectionImmersive>
                    <v-card outlined rounded="" data-aos="fade" data-aos-delay="100">
                        <v-responsive :aspect-ratio="1200 / 770" content-class="d-flex align-center justify-center">
                            <div class="pa-30px pa-md-40px px-lg-80px">
                                <v-img max-width="696" :aspect-ratio="696 / 474" src="/images/sub/solution/plant/rearing-img3.jpg" class="mx-auto" />
                                <div class="pt-30px pt-md-40px pt-lg-60px">
                                    <tit-wrap-small>
                                        <template #text>Once you enter threshold values in the cultivation system, its warning unit issues a warning whenever any of the preset threshold values is exceeded; thus realizing the most efficient cultivation.</template>
                                    </tit-wrap-small>
                                </div>
                            </div>
                        </v-responsive>
                    </v-card>
                </template>
            </page-section>

            <page-section class="page-section--sm pb-0">
                <template #pageSectionImmersive>
                    <v-row justify="center">
                        <v-col cols="12" md="6" lg="4" data-aos="fade" data-aos-delay="100">
                            <v-card outlined rounded="">
                                <v-img max-width="382" :aspect-ratio="382 / 540" src="/images/sub/solution/plant/rearing-img4.jpg" class="ma-auto" />
                            </v-card>
                            <tit-wrap-small mbSmall class="mt-14px mt-md-20px">
                                Registered Patent
                                <template #text>
                                    Apparatus for Managing Nutriculture
                                </template>
                            </tit-wrap-small>
                        </v-col>
                    </v-row>
                </template>
            </page-section>
        </page-section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/pages/client/templates/page-section.vue";
import TitWrapSmall from "@/components/dumb/tit-wrap-small.vue";
import TitWrapLarge from "@/components/dumb/tit-wrap-large.vue";
import TitWrapSprout from "@/components/dumb/tit-wrap-sprout.vue";
import TxtItem from "@/components/dumb/txt-item.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        TitWrapSmall,
        TitWrapLarge,
        TitWrapSprout,
        TxtItem,
    },
    props: {},
    data() {
        return {
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {});
        },
    },
};
</script>

<style lang="scss" scoped></style>
